import React from "react";
import PropTypes from "prop-types";
import { Card, Col, Row, Statistic } from "antd";

/** Rangée de compteurs ; « … » pendant le chargement. */
const StatCards = ({ stats, loading }) => (
    <Row gutter={[16, 16]}>
        {stats.map((stat) => (
            <Col key={stat.title} xs={12} md={24 / Math.min(stats.length, 4)}>
                <Card>
                    <Statistic title={stat.title} value={loading ? "…" : stat.value} />
                </Card>
            </Col>
        ))}
    </Row>
);

StatCards.propTypes = {
    stats: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    })).isRequired,
    loading: PropTypes.bool
};

export default StatCards;
